const LOGIN_WIDGET__REGISTER = () => ({
    category: 'login-widget',
    action: 'click',
    label: 'register',
});
const LOGIN_WIDGET__FORGOT_PASSWORD = () => ({
    category: 'login-widget',
    action: 'click',
    label: 'forgot-password',
});
const LOGIN_WIDGET__LOGIN_SUCCESS = () => ({
    category: 'login-widget',
    action: 'login',
    label: 'regular',
});
const LOGIN_WIDGET__FB_LOGIN = () => ({
    category: 'login-widget',
    action: 'login',
    label: 'facebook',
});
const LOGIN_WIDGET__LOGIN = () => ({
    category: 'login-widget',
    action: 'click',
    label: 'login',
});
const LOGIN_WIDGET__REGISTER_SUCCESS = () => ({
    category: 'login-widget',
    action: 'register',
    label: 'regular',
});
const LOGIN_WIDGET__SAVE_ACCOUNT = () => ({
    category: 'login-widget',
    action: 'save',
    label: 'account',
});
const LOGIN_WIDGET__CHANGE_PASSWORD = () => ({
    category: 'login-widget',
    action: 'save',
    label: 'change-password',
});
const LOGIN_WIDGET__ACCOUNT = () => ({
    category: 'login-widget',
    action: 'click',
    label: 'account',
});
const LOGIN_WIDGET__LOGOUT = () => ({
    category: 'login-widget',
    action: 'click',
    label: 'logout',
});
const LOGIN_WIDGET__FORGOT_PASSWORD_SUBMIT = () => ({
    category: 'login-widget',
    action: 'submit',
    label: 'forgot-password',
});
const MY_TRANSACTION__LOGIN = (pagePath) => ({
    category: 'ux_showroom_my_transaction',
    action: 'click',
    label: `${pagePath} | Login`,
});
const MY_TRANSACTION__CREATE_AN_ACCOUNT = (pagePath) => ({
    category: 'ux_showroom_my_transaction',
    action: 'click',
    label: `${pagePath} | create_an_account`,
});
const MY_TRANSACTION__GARAGE = (pagePath) => ({
    category: 'ux_showroom_my_transaction',
    action: 'click',
    label: `${pagePath} | my_garage`,
});
const MY_TRANSACTION__TRADEIN = (pagePath) => ({
    category: 'ux_showroom_my_transaction',
    action: 'click',
    label: `${pagePath} | my_trade_in`,
});
const MY_TRANSACTION__FINANCE = (pagePath) => ({
    category: 'ux_showroom_my_transaction',
    action: 'click',
    label: `${pagePath} | finance`,
});

export default {
    LOGIN_WIDGET__REGISTER,
    LOGIN_WIDGET__FORGOT_PASSWORD,
    LOGIN_WIDGET__LOGIN_SUCCESS,
    LOGIN_WIDGET__FB_LOGIN,
    LOGIN_WIDGET__LOGIN,
    LOGIN_WIDGET__REGISTER_SUCCESS,
    LOGIN_WIDGET__SAVE_ACCOUNT,
    LOGIN_WIDGET__CHANGE_PASSWORD,
    LOGIN_WIDGET__ACCOUNT,
    LOGIN_WIDGET__LOGOUT,
    LOGIN_WIDGET__FORGOT_PASSWORD_SUBMIT,
    MY_TRANSACTION__LOGIN,
    MY_TRANSACTION__CREATE_AN_ACCOUNT,
    MY_TRANSACTION__GARAGE,
    MY_TRANSACTION__TRADEIN,
    MY_TRANSACTION__FINANCE,
};
